import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addEmployee } from "./EmployeeServices";
import { formFields, validationSchema } from "./EmployeeSchema";

export const EmployeeAdd = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Add Job Seaker" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={addEmployee}
                                    listPageKey='EMPLOYEE_LIST'
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
